export const ContextTokens = {
    Auth: "AuthContext",
} 